import { Solution } from "@labs/shared/types/Solution.ts";
import { Chip, Stack, Typography } from "@mui/material";
import { pillarLabelMap } from "../data/pillarLabelMap";
import { SliderWithAccordion } from "./SliderWithAccordion";
import { Control, FieldValues } from "react-hook-form";
import { LabsCard } from "./LabsCard.tsx";
import { CostScoreDisplay } from "./CostScoreDisplay";
import { InvestmentLarge } from "./InvestmentLarge.tsx";

type SolutionEntryProps<T extends FieldValues> = {
  solution: Solution;
  control: Control<T>;
};

export const SolutionEntry = <T extends FieldValues>({
  solution,
  control,
}: SolutionEntryProps<T>) => {
  return (
    <LabsCard>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" gutterBottom id={solution.name}>
          {solution.label}
        </Typography>
        <InvestmentLarge costScore={solution.costScore} />
      </Stack>
      <SliderWithAccordion
        control={control}
        label={solution.label}
        description={solution.description}
        name={solution.name}
      />
      <Stack direction="row" spacing={1} mt={1}>
        <Chip
          label={<CostScoreDisplay costScore={solution.costScore} />}
          variant="outlined"
        />
        <Chip label={`Scope ${solution.scope}`} variant="outlined" />
        <Chip label={pillarLabelMap[solution.pillar]} variant="outlined" />
      </Stack>
    </LabsCard>
  );
};
